<template>
  <div class="log" />
</template>

<script>
import store from '@/store/store'

export default {
  async created() {
    await store.dispatch('userLogout')
    this.$router.push({ name: 'auth' })
  },
}
</script>

<style>
</style>
<style>
</style>
